import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@context/AuthContext";
import { FavoritesProvider } from "@context/FavoritesContext";
import { UIProvider } from "@context/UIContext";
import { ToastContainer } from "@components/ui";
import AppRoutes from "@router/index";

/**
 * Root application component.
 *
 * Wires the provider tree (Auth, Favorites, UI) and mounts the real route
 * tree (src/router/index.jsx) — completed in Phase 4 now that MVP pages
 * exist. Router must wrap Auth because ProtectedRoute/AdminRoute call
 * `useLocation`/`useNavigate`, which require Router context.
 */
export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <FavoritesProvider>
          <UIProvider>
            <AppRoutes />
            <ToastContainer />
          </UIProvider>
        </FavoritesProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
